var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLotteryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2,11.46c-2.39,0-4.46,1.32-5.57,3.26-4.03-6.62-11.23-10.72-19.01-10.72C15.35,4,5.35,13.99,5.35,26.28c0,8.59,4.95,16.33,12.64,20.04l-1.71,5.92h-1.39c-2.14,0-3.88,1.74-3.88,3.88s1.74,3.88,3.88,3.88h25.46c2.14,0,3.88-1.74,3.88-3.88s-1.74-3.88-3.88-3.88h-1.39l-1.71-5.92c7.69-3.7,12.65-11.44,12.65-20.03,0-.8-.05-1.61-.13-2.41,.75,.31,1.57,.48,2.43,.48,3.55,0,6.44-2.89,6.44-6.44s-2.89-6.44-6.44-6.44Zm-16.36,29.93l-.9-3.12c.82,.21,1.46,.93,1.46,1.81,0,.51-.22,.97-.56,1.31Zm-8.21-9.41c-3.14,0-5.7-2.56-5.7-5.7s2.57-5.7,5.7-5.7c1.82,0,3.59,.83,4.74,2.62h-4.74c-1.7,0-3.08,1.38-3.08,3.08s1.38,3.08,3.08,3.08h4.74c-1.03,1.59-2.78,2.62-4.74,2.62Zm-7.43,6.68c-.6-.32-1.01-.94-1.01-1.66,0-1.05,.85-1.9,1.9-1.9,.04,0,.08,.03,.13,.03l-1.02,3.53Zm-1.03-14.92c0-1.03,.87-1.9,1.9-1.9,.08,0,.16,.03,.24,.04-.69,.99-1.12,2.15-1.29,3.39-.5-.35-.85-.9-.85-1.54Zm14.11-2.58c-.84-.93-1.86-1.67-3.04-2.1,.32-.6,.95-1.02,1.67-1.02,1.05,0,1.9,.85,1.9,1.9,0,.47-.23,.88-.53,1.22Zm-5.65,6.2c-.6,0-1.08-.49-1.08-1.08s.49-1.08,1.08-1.08h9.3c.45,0,.85-.3,.97-.74l1.83-6.83c.13-.47,.56-.8,1.05-.8h5.09c-.06,.35-.11,.71-.11,1.08s.05,.73,.11,1.08h-3.49c-.45,0-.85,.3-.97,.74l-1.83,6.83c-.13,.47-.56,.8-1.05,.8h-10.91Zm-20.28-1.08C7.35,15.1,16.45,6,27.63,6c6.7,0,12.92,3.36,16.68,8.82h-3.53c-1.39,0-2.62,.94-2.98,2.29l-1.63,6.08h-1.57c-.05-.1-.1-.2-.15-.3,.85-.73,1.37-1.8,1.37-2.95,0-2.15-1.75-3.9-3.9-3.9-1.68,0-3.09,1.11-3.62,2.64-.22-.02-.43-.1-.66-.1-1.83,0-3.49,.67-4.81,1.74-.54-.28-1.12-.47-1.74-.47-2.15,0-3.9,1.75-3.9,3.9,0,1.76,1.24,3.22,2.87,3.68,.25,1.67,1.01,3.17,2.16,4.31l-.42,1.45c-.23-.04-.46-.09-.69-.09-2.15,0-3.9,1.75-3.9,3.9,0,1.62,1.02,2.99,2.46,3.58l-1.09,3.78c-6.83-3.43-11.21-10.37-11.21-18.08Zm34.89,29.84c0,1.04-.84,1.88-1.88,1.88H14.9c-1.04,0-1.88-.85-1.88-1.88s.85-1.88,1.88-1.88h25.46c1.04,0,1.88,.85,1.88,1.88Zm-17.56-3.88l.69-7.17c.11-1.13,.86-2.34,2.25-2.34s2.15,1.21,2.25,2.34l.69,7.17h-5.89Zm7.89,0l-.71-7.36c-.23-2.41-2.02-4.15-4.25-4.15s-4.01,1.75-4.24,4.15l-.71,7.36h-4.31l5.56-19.24c1.1,.61,2.36,.99,3.71,.99s2.58-.42,3.69-1.04l5.57,19.29h-4.31Zm4.12-7.87l-.27-.93c1.19-.68,1.97-1.93,1.97-3.35,0-2.15-1.75-3.9-3.9-3.9-.05,0-.1,.02-.16,.02l-1.32-4.56c.65-.65,1.18-1.41,1.56-2.28h3.94c1.39,0,2.62-.94,2.98-2.29l1.63-6.08h3.44c.26,.47,.56,.9,.92,1.29,.26,1.31,.41,2.66,.41,4,0,7.71-4.38,14.66-11.21,18.08Zm15.5-22.01c-2.45,0-4.44-1.99-4.44-4.44s1.99-4.44,4.44-4.44,4.44,1.99,4.44,4.44-1.99,4.44-4.44,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.63,35.45c-.55,0-1,.45-1,1v1.55c0,.55,.45,1,1,1s1-.45,1-1v-1.55c0-.55-.45-1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.89,29.43h0c-2.15,0-3.9,1.75-3.9,3.9s1.75,3.9,3.9,3.9,3.9-1.75,3.9-3.9-1.75-3.9-3.9-3.9Zm0,5.8c-1.05,0-1.9-.85-1.9-1.9s.85-1.9,1.9-1.9c1.05,0,1.9,.85,1.9,1.9s-.87,1.9-1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.35,27.27c-2.15,0-3.9,1.75-3.9,3.9s1.75,3.9,3.9,3.9,3.9-1.75,3.9-3.9-1.75-3.9-3.9-3.9Zm0,5.8c-1.05,0-1.9-.85-1.9-1.9s.85-1.9,1.9-1.9,1.9,.85,1.9,1.9-.85,1.9-1.9,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.88,19.24c2.15,0,3.9-1.75,3.9-3.9,0-2.15-1.75-3.9-3.9-3.9s-3.9,1.75-3.9,3.9,1.75,3.9,3.9,3.9Zm0-5.79h0c1.03,0,1.9,.87,1.9,1.9,0,1.05-.85,1.9-1.9,1.9s-1.9-.87-1.9-1.9,.87-1.9,1.9-1.9Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "a`"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ab"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "ae"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "af"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "ag"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "ah"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "ai"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "aj"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "ak"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "al"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "am"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "an"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "ao"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "ap"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "aq"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "ar"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "as"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "at"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "au"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "av"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "aw"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "ax"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotteryIcon);
export default __webpack_public_path__ + "static/media/lotteryIcon.153a35ddd79dcc51cde64d1fcbac75fe.svg";
export { ForwardRef as ReactComponent };